<template>
  <ul class="address-list">
    <li :class="{active: isSelect ? index === selectIndex : item.is_default === 1}"
        v-for="(item, index) in list"
        :key="index"
        @click="clickAddress(index, item)"
    >
      <span class="user-name">{{ item.name }}</span>
      <span class="user-msg">{{ item.full_address }}</span>
      <span class="user-num">{{ item.mobile_show }}</span>
      <div class="address-btn-box">
        <button type="button" @click="address = item; showEdit = true">修改</button>
        <button type="button" @click="deleteAddress(item.id)">删除</button>
      </div>
    </li>
    <normal-box :show="list.length === 0" />
    <address-save-dialog v-model="showEdit" :address-data="address" @submitSuccess="getList()" />
  </ul>

</template>

<script>

import {MemberaddressService} from "@/common/service";
import NormalBox from "@/components/normal-box";
import {Message, MessageBox} from "element-ui";
import AddressSaveDialog from "@/components/address-save-dialog";

export default {
  name: 'address-list',
  components: {AddressSaveDialog, NormalBox},
  props: {
    isSelect: {
      default: false,
    },
  },
  data() {
    return {
      selectIndex: -1,

      showEdit: false,
      address: null,
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    clickAddress(index, item) {
      if (this.isSelect) {
        this.selectIndex = index;
        this.$emit('select', item);
      }
    },

    editAddress(item) {

    },
    deleteAddress(id) {
      MessageBox({
        type: 'warning',
        title: '提示',
        message: '确定删除地址吗？',
        showCancelButton: true,
      }).then(() => {
        MemberaddressService.delete(({id})).then(() => {
          Message.success('删除成功！');
          this.getList();
        });
      });
    },
    getList() {
      MemberaddressService.page().then(({data}) => {
        this.list = data.list.map(item => ({
          ...item,
          mobile_show: item.mobile
              .split('')
              .map((str, index) => index > 2 && index < 7 ? '*' : str)
              .join(''),
        }));
      });
    },
  },
}
</script>

<style scoped>

.address-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 20px 0 50px;
  box-sizing: border-box;
}

.address-list>li {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333333;
  font-size: 16px;
  margin-bottom: 17px;
}

.user-msg {
  width: 291px;
}

.user-name {
  height: 29px;
  line-height: 29px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 11px;
}

.address-list>li.active {
  color: #FF6619;
}

.address-list>li.active .user-name {
  border: 1px solid #FF6619;
  border-radius: 4px;
}

.address-list>li.active .user-name::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: -1px;
  width: 18px;
  height: 17px;
  background: url(../assets/selected.png) no-repeat;
  background-size: 100% 100%;
}

.address-btn-box {
  display: flex;
  align-items: center;
}

.address-btn-box>button {
  color: #333333;
  font-size: 16px;
  padding: 0 10px;
  margin-right: 5px;
}

.address-btn-box>button:last-child {
  margin-right: 0;
}

</style>
